module.exports = __webpack_public_path__ + "img/share-feedback.71f12245.jpg";